export default __webpack_public_path__ + "assets/images/0b48432d3450d5582f1beac37feb6e85.jpg";